import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from '../styles/aboutcomponent.module.css';

import snehwanFounder from '../../../assets/about/projects/image_001.jpeg';
import children_playing from '../../../assets/about/projects/image_012.jpeg';
import CountUp from 'react-countup';
import { useInView } from 'framer-motion';

const AboutIndex = () => {
  const [numbersData, setNumbersData] = useState([]);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    const staticNumbers = [
      { key: 'years of work', value: '9 +' },
      { key: 'Projects', value: '8 +' },
      { key: 'Children', value: '250 +' },
      { key: 'Awards', value: '100 +' },
      {
        key: 'Reviews',
        value: '750 +',
        link: 'https://www.google.com/search?q=snehwan+google+review',
        rating: '4.9',
      },
    ];
    setNumbersData(staticNumbers);
  }, []);

  const memoizedNumbersData = useMemo(() => numbersData, [numbersData]);

  return (
    <div className={styles.about_component}>
      <div className={styles.about_component_we_are_snehwan}>
        <div>
          <h2>Healing Wings for the Children of Our Soil</h2>
          <p>
            The hands that feed the nation—our farmers—are fighting a losing
            battle against a changing climate. When droughts and floods push
            our Annadatas to the brink of despair, the tragedy doesn't end
            with a life lost; it echoes in the silence of the families left
            behind.
          </p>
          <p>But at Snehwan, we refuse to let darkness be the final chapter.</p>
          <p>
            Founded in 2015 by Ashok Deshmane near the holy grounds of
            Alandi, Snehwan is more than an organization; it is a promise. We
            believe that the children of these unsung heroes deserve more
            than just survival—they deserve to soar. We provide a sanctuary
            where education meets compassion, transforming grief into grit.
          </p>
          <p>
            Here, we don't just teach subjects; we build character. We
            prepare our children to face competitive exams, fight injustice,
            and rise as compassionate leaders. We are turning a legacy of
            struggle into a future of triumph.
          </p>
        </div>
        <div>
          <img src={snehwanFounder} alt="snehwanFounder" loading="lazy" />
          <img src={children_playing} alt="j1" loading="lazy" />
        </div>
      </div>

      <div className={styles.number_counting_strip} ref={ref}>
        {memoizedNumbersData.map((item, index) => (
          <div key={index} className={styles.counting_item}>
            {isInView && (
              <h1 className={styles.counting_value}>
                {item.key === 'Reviews' ? (
                  <a
                    href="https://www.google.com/search?q=snehwan+google+review"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#D38232', textDecoration: 'none', cursor: 'pointer' }}
                  >
                    <CountUp start={0} end={parseInt(item.value.replace(/[^0-9]/g, ''), 10)} duration={5} /> +
                  </a>
                ) : (
                  <>
                    <CountUp start={0} end={parseInt(item.value.replace(/[^0-9]/g, ''), 10)} duration={5} /> +
                  </>
                )}
              </h1>
            )}
            <p className={styles.counting_key}>{item.key}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutIndex;